import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-daily-operation',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './daily-operation.component.html',
  styleUrl: './daily-operation.component.css',
})
export class DailyOperationComponent {}
